export const CONFIG = {
	usersWebApi: process.env.REACT_APP_USERS_WEB_API,
	mainProxyApi: process.env.REACT_APP_MAIN_PROXY_API,
	historyApi: process.env.REACT_APP_HISTORY_API,
	apiDomain: process.env.API_DOMAIN
}
